import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/_table/Table';
import BaseForm from '../../../../../components/form/BaseForm';
import { setPhoneFormat, setNumberWithComma } from '../../../../../lib/common';
import columns from './columns';
import './BuyerPurchaseHistoryModal.scss';

const BuyerPurchaseHistoryModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { buyerHistoryInfo, buyerHistoryList } = data;

  return (
    <Modal
      title="구매 이력"
      isOpen={isOpen}
      width={800}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="buyer-purchase-history-modal-wrap">
        <div className="user-info">
          <BaseForm label="구매자명" content={buyerHistoryInfo.buyerName} />

          <BaseForm label="구매자 전화번호" content={setPhoneFormat(buyerHistoryInfo.buyerPhone)} />

          <BaseForm
            label="구매 횟수"
            content={
              <Fragment>
                {setNumberWithComma(buyerHistoryInfo.orderCnt, '회')}(
                {setNumberWithComma(buyerHistoryInfo.orderItemCnt, '개')}
                상품)
              </Fragment>
            }
          />

          <BaseForm label="결제 금액" content={setNumberWithComma(buyerHistoryInfo.totalPrice, '원')} />
        </div>

        <Table
          className="buyer-purchase-history-list-table"
          rowKey={(record) => record.orderItemId}
          list={buyerHistoryList}
          showSizeChanger={false}
          scroll={{ x: true }}
          columns={() => columns()}
        />
      </div>
    </Modal>
  );
};

export default BuyerPurchaseHistoryModal;
